import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { DecorativeDiamond } from './ui/DecorativeDiamond';
export function OpeningHook() {
  return <section className="py-20 bg-brand-rose text-white relative overflow-hidden clip-diagonal" data-id="element-94">
      <DecorativeDiamond className="top-10 left-10 w-24 h-24" color="gold" data-id="element-95" />
      <DecorativeDiamond className="bottom-10 right-10 w-32 h-32" color="pink" data-id="element-96" />

      <div className="container mx-auto px-6 relative z-10" data-id="element-97">
        <div className="max-w-3xl mx-auto text-center" data-id="element-98">
          <FadeIn data-id="element-99">
            <h2 className="text-3xl md:text-4xl font-bold mb-8 text-brand-cream" data-id="element-100">
              ¿Sabes qué es lo más caro en Estados Unidos?{' '}
              <span className="text-brand-gold" data-id="element-101">Tener un mal crédito.</span>
            </h2>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-102">
            <p className="text-lg md:text-xl leading-relaxed text-brand-cream/90 font-light" data-id="element-103">
              Cada vez que te dicen "Lo siento, no calificas", o terminas
              pagando intereses del 20% en un auto que no lo vale, estás
              perdiendo el dinero que debería ser para el futuro de tus hijos.
              El sistema no es justo, pero hoy vas a aprender a ganarle en su
              propio juego.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}